import { Box, Button, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import axios from "axios";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AdminNavbar from "../components/nav-bar";
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ReviewingArticles from "../components/reviewing-articles";
import PeerReviewers from "../components/peer-reviewers";
import PendingPeerReviews from "../components/pending-peer-reviews";

function PeerReviewersPage() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get("status");
    
    return (
        <Box>
            <AdminNavbar/>
       
            <Box sx={{ padding: 2 }}>
              {status === '0' && <PendingPeerReviews/>}
              {status === '1' && <PeerReviewers/>}
            </Box>
        </Box>
    );
}

export default PeerReviewersPage;
